az<template>
  <div class="post-comment">
    <div class="user-comment">
      <div v-for="(comment,index) in commentList" :key="index" class="comment-box">
        <div class="separator"></div>
        <div class="user-info">
          <div class="avatar">
            <img :src="resourceUrl(getAvatar,'avatar')">
          </div>
          <div class="username-time">
            <div class="name">{{ comment.nickName }}</div>
            <div class="time">{{ comment.createTime }}</div>
          </div>
        </div>
        <div class="textarea">
          <span>{{ comment.content }}</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'h-comment-list',
  props:{
    commentList:{
      type:Array,
      default: () => []
    }
  },
  computed: {
    getAvatar() {
      return this.$store.getters.avatar;
    },
  },
  data(){
    return{
    }
  },
  methods:{
  },
}
</script>

<style scoped>

.todo-comment .textarea{
  width: 90%;
}
.todo-comment .button{
  width: 10%;
  margin-top: auto;
}
.user-comment{

  /*display: flex;*/
  /*background: #fff;*/
  /*padding: 10px;*/
}
.comment-box{
  width: 100%;
  /*display: flex;*/
  /*margin-top: 10px;*/
  background: #fff;
  padding: 10px;
}
.comment-box .user-info{
  /*width: 20%;*/
  display: flex;
}
.comment-box .user-info .avatar{
  width: 30px;
  height: 30px;
}
.comment-box .user-info .username-time {
  margin-left: 10px;
}
.comment-box .user-info .username-time .name{
  font-weight: bold;
  font-size: 13px;
  text-align: left;
}
.comment-box .user-info .username-time .time{
  font-size: 12px;
  color: #808080FF;
}
.comment-box .textarea{
  width: 100%;
  text-align: left;
  font-size: 14px;
  padding: 10px;
  padding-left: 3em;
  white-space:pre-line;
}
</style>
